export const SKINS = {
  DEFAULT: 'default',
  WSB: 'wsb',
}

